<template>
  <p>
    Você não tem permissão para acessar essa página.
  </p>
</template>

<script>
  export default {
    name: 'NoPermission',
    data: () => ({}),
  }
</script>